import { useFlags } from 'flagsmith/react';
import { type IFlagsmithFeature } from 'flagsmith/types.d';

import { type FeatureFlagValues } from 'app/api/services/site-configs/types';

export const useCheckFeatureFlagValue = <T extends FeatureFlagValues, K extends keyof T>(
  featureFlag: K,
  variationValue: IFlagsmithFeature['value'] & T[K],
) => {
  const flagsmithFeatureFlag = useFlags([featureFlag.toString()]);

  return flagsmithFeatureFlag[featureFlag].value === variationValue;
};
